import React from "react";
import {
  IResolveParams,
  LoginSocialApple,
  LoginSocialGoogle,
} from "reactjs-social-login";
import {
  AppleLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";

type Provider = "Google" | "Apple";

type providersIcon = {
  [item in Provider]?: React.ReactNode;
};

interface ISocialAuth {
  className?: string;
  providers: Provider | Array<Provider>;
  clientIds?: Record<Provider, string | undefined>;
  providersIcon?: providersIcon;
  providersRelatedClassName?: Record<Provider, string>;
  redirectUrl?: any;
  rest?: any;
  onLoginStartSocialAuthStart: () => void;
  onResolveSocialAuth: (
    provider: IResolveParams["provider"],
    data: IResolveParams["data"]
  ) => void;
  onRejectSocialAuth: (err: any) => void;
}

const defaultClientIds = {
  Google: process.env.REACT_APP_GG_APP_ID,
  Apple: process.env.REACT_APP_APPLE_ID,
};

const defaultRedirectUrls = {
  Apple: window.location.href,
  Google: window.location.href,
};

const SocialAuth = ({
  clientIds = { ...defaultClientIds },
  providersIcon,
  providersRelatedClassName,
  providers,
  className,
  redirectUrl = { ...defaultRedirectUrls },
  rest,
  onLoginStartSocialAuthStart,
  onResolveSocialAuth,
  onRejectSocialAuth,
}: ISocialAuth) => {
  const [googleAuthKey, setGoogleAuthKey] = React.useState(0);

  return (
    <div className={className} {...rest}>
      {(providers === "Google" || providers.includes("Google")) && (
        <LoginSocialGoogle
          key={googleAuthKey}
          isOnlyGetToken
          client_id={clientIds.Google || ""}
          scope={"profile email"}
          onLoginStart={onLoginStartSocialAuthStart}
          onResolve={({ provider, data }: IResolveParams) => {
            onResolveSocialAuth(provider, data);
          }}
          onReject={(err) => {
            setGoogleAuthKey((k) => k + 1);
            onRejectSocialAuth(err);
          }}
        >
          <div
            className={providersRelatedClassName?.Google}
            style={{ marginBottom: "8px" }}
          >
            {providersIcon?.Google || <GoogleLoginButton />}
          </div>
        </LoginSocialGoogle>
      )}

      {(providers === "Apple" || providers.includes("Apple")) && (
        <LoginSocialApple
          client_id={clientIds.Apple || ""}
          scope={"name email"}
          redirect_uri={redirectUrl.Apple}
          onLoginStart={onLoginStartSocialAuthStart}
          onResolve={({ provider, data }: IResolveParams) => {
            onResolveSocialAuth(provider, data);
          }}
          onReject={(err) => {
            onRejectSocialAuth(err);
          }}
        >
          <div className={providersRelatedClassName?.Apple}>
            {providersIcon?.Apple || <AppleLoginButton />}
          </div>
        </LoginSocialApple>
      )}
    </div>
  );
};

export default SocialAuth;
